"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandToClient = void 0;
exports.brandToClient = {
    qualitas: 'admiral',
    balumba: 'admiral',
    realemutua: 'realemutua',
    italianaassicurazioni: 'realemutua',
};
